import React, { useState, useEffect } from "react";
import Accordion from "../../../../revampComponents/Atom/Accordion";
import KonfhubContainer from "../../../../revampComponents/Atom/Container";
import {
	configureCustomSenderEmailName,
	fetchReplyToAddressEmail,
	fetchSenderEmailDetails,
	removeCustomSenderEmail,
	sendReplyToAddressEmail
} from "../../../../revampCRUD/Advanced/Customization.crud";
import Caution from "../../../../assets/Caution.svg";
import Refresh from "../../../../assets/refresh_customization_email.svg";
import GreenTick from "../../../../../src/assets/pages/Section/Advanced/Customization/GreenTick.svg";
import { DeleteModal } from "../../../../revampComponents/Atom/Modals";
import { checkPotentialDomainTypo } from "../../../../Utils/helpers";
import customToast from "../../../../components/common/basic/Toast";
import WebsiteIntegrations from "./WebsiteIntegrations";
import LinkedInShareCustomization from "./LinkedInShareCustomization";
import { useFormik } from "formik";
import * as Yup from "yup";
import { colors, dashboardColors, theme, websiteColors } from "../../../../themes/Theme";
import { configureSenderEmail, deleteSenderEmail, EditEventProfileApi, GetEventProfileById, getSenderEmail } from "../../../../revampCRUD/eventProfile.curd";
import BrandingAndCustomizationNote from "../BrandingAndCustomizationNote";
import ToolTip from "../../../../revampComponents/Atom/ToolTip";

const Customization = props => {
	const { module, profileId, eventInfo, isRestricted } = props;
	const isEventProfile = module === "event-profile";
	const [accordion, setAccordion] = useState("Communication Channels");
	const [isApiCalled, setIsApiCalled] = useState(false);
	const [initialReplyToEmail, setInitialReplyToEmail] = useState("");
	const [loading, setLoading] = useState(true);

	function onAccordionClick(label) {
		label == accordion ? setAccordion("Close ALL") : setAccordion(label);
	}

	const [state, setState] = useState({
		data: {
			sendersName: "",
			sendersEmail: ""
		},
		value: false,
		isSenderVerified: false,
		isSenderDomainVerified: false,
		dnsRecords: null,
		loading: false,
		saveBtnLoading: false,
		showVerifyButton: false,
		errors: {
			sendersName: "",
			sendersEmail: ""
		}
	});

	const [customName, setCustomName] = useState("");

	const [customEmail, setCustomEmail] = useState("");

	const [verificationTimer, setVerificationTimer] = useState(null);

	const [isEmailInputDisabled, setIsEmailInputDisabled] = useState(false);

	const [openDeleteModal, setOpenDeleteModal] = useState(false);

	const validationSchema = Yup.object({
		reply_to_address: Yup.string()
			.test(
				"custom-email-validation",
				"Please enter a valid email address",
				value =>
					!value || // let `required` handle empty
					/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(value)
			),
	});

	const getReplyEmail = async (eventId) => {
		try {
			if (isEventProfile) {
				const response = await GetEventProfileById(profileId);
				const email = response?.data?.event_profile?.reply_to_address || "";
				setInitialReplyToEmail(email);
			} else {
				const response = await fetchReplyToAddressEmail(eventId);
				const email = response?.data?.reply_to_address || "";
				setInitialReplyToEmail(email);
			}
		} catch (err) {
			customToast.error(err?.response?.data?.error || "Something went wrong");
		}
	};

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			reply_to_address: initialReplyToEmail,
		},
		validationSchema,
		onSubmit: async (values, { setSubmitting }) => {
			if (values?.reply_to_address !== initialReplyToEmail) {
				try {
					if (!isEventProfile) {
						const response = await sendReplyToAddressEmail(props?.eventInfo?.event_id, {
							reply_to_address: values?.reply_to_address || null,
						});
						if (response.status === 200) {
							await getReplyEmail(props?.eventInfo?.event_id);
							customToast.success('Saved successfully!');
						}
						setInitialReplyToEmail(values?.reply_to_address);
					} else {
						const response = await EditEventProfileApi(profileId, { reply_to_address: values?.reply_to_address, })
						if (response.status === 200) {
							await getReplyEmail(props?.eventInfo?.event_id);
							customToast.success('Saved successfully!');
						}
						setInitialReplyToEmail(values?.reply_to_address);
					}
				} catch (err) {
					customToast.error(err?.response?.data?.error || "Something went wrong");
				}
			}
			setSubmitting(false);
		},
	});
	const updateCustomizationDetails = async () => {
		const response = await EditEventProfileApi(profileId, {
			sender_email: state?.data?.sendersEmail
		})
		setState((prevState) => {
			return {
				...prevState,
				showVerifyButton: false,
				loading: false,
				isSenderVerified: true,
				saveBtnLoading: false
			}
		});
	}
	const getSenderEmailDetails = async (eventId, value = true) => {
		setState({ ...state, value: value });
		setLoading(true);
		try {
			let response
			let _showVerifyButton = false;
			if (isEventProfile) {
				response = await getSenderEmail(profileId);
				_showVerifyButton =
					!response?.data?.is_sender_verified &&
						(response?.data?.sender_name !== null ||
							response?.data?.sender_name !== undefined ||
							response?.data?.sender_name !== "") &&
						!response?.data?.sender_email
						? true
						: false;
				setState({
					...state,
					value: false,
					showVerifyButton: _showVerifyButton,
					isSenderVerified: response?.data?.is_sender_verified,
					isSenderDomainVerified: response?.data?.is_sender_domain_verified,
					dnsRecords: response?.data?.dns_records || null,
					data: {
						sendersName: response?.data?.sender_name || "",
						sendersEmail: response?.data?.sender_email || ""
					}
				});
				setIsEmailInputDisabled(
					(response?.data?.sender_email === null ||
						response?.data?.sender_email === "" ||
						response?.data?.sender_email === undefined)
						? false
						: true
				);
				setCustomEmail(response?.data?.sender_email);
				setCustomName(response?.data?.sender_name);
				if (response?.data?.is_sender_verified) {
					setVerificationTimer(0);
					return true;
				} else {
					return false;
				}
			} else {
				response = await fetchSenderEmailDetails(eventId);
				_showVerifyButton =
					!response?.data?.is_sender_verified &&
						(response?.data?.sender_name !== null ||
							response?.data?.sender_name !== undefined ||
							response?.data?.sender_name !== "") &&
						!response?.data?.sender_email
						? true
						: false;
				setState({
					...state,
					value: false,
					showVerifyButton: _showVerifyButton,
					isSenderVerified: response.data.is_sender_verified,
					isSenderDomainVerified: response.data.is_sender_domain_verified,
					dnsRecords: response?.data?.dns_records || null,
					data: {
						sendersName: response.data.sender_name,
						sendersEmail: response.data.sender_email || ""
					}
				});
				setIsEmailInputDisabled(
					verificationTimer <= 0 &&
						!response.data.is_sender_verified &&
						(response.data.sender_email === null ||
							response.data.sender_email === "" ||
							response.data.sender_email === undefined)
						? false
						: true
				);
				setCustomEmail(response.data.sender_email);
				setCustomName(response.data.sender_name);
				if (response.data.is_sender_verified) {
					setVerificationTimer(0);
					return true;
				} else {
					return false;
				}
			}
		} catch (error) {
			customToast.error(error.message);
			setState({ ...state, value: false });
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		//Implementing the setInterval method
		let _verificationTimer = verificationTimer;
		const timer = setInterval(() => {
			if (_verificationTimer > 0) {
				_verificationTimer--;
				setVerificationTimer(_verificationTimer);
			} else {
				clearInterval(timer);
				setVerificationTimer(0);
				return;
			}
		}, 1000);
		//Clearing the interval
		return () => {
			clearInterval(timer);
		};
	}, [verificationTimer]);
	const sendCustomSenderEmail = async eventId => {
		try {
			let response;
			if (isEventProfile) {
				response = await configureSenderEmail(profileId, {
					sender_name: state?.data?.sendersName,
					sender_email: state?.data?.sendersEmail
				});
			} else {
				response = await configureCustomSenderEmailName(eventId, {
					sender_name: state?.data?.sendersName,
					sender_email: state?.data?.sendersEmail
				});
			}
			if (response?.status === 200) {
				if (response?.data?.msg === "Sender email domain yet to be verified" && response?.data?.is_sender_verified && !response?.data?.is_sender_domain_verified) {
					setVerificationTimer(60);
					setState((prevState) => {
						return {
							...prevState,
							showVerifyButton: false,
							loading: false,
							isSenderVerified: true,
							isSenderDomainVerified: false,
							dnsRecords: response?.data?.dns_records || null,
							saveBtnLoading: false
						}
					});
					setCustomEmail(response?.data?.sender_email);
					setCustomName(response?.data?.sender_name);
					customToast.success("Saved successfully!");
				}
			}

			if (response?.status === 200) {
				if (response?.data?.msg === "Sender email added successfully and initiated verification process" && !response?.data?.is_sender_verified && response?.data?.is_sender_domain_verified) {
					setVerificationTimer(60);
					setState((prevState) => {
						return {
							...prevState,
							showVerifyButton: false,
							loading: false,
							isSenderVerified: false,
							isSenderDomainVerified: true,
							dnsRecords: response?.data?.dns_records || null,
							saveBtnLoading: false
						}
					});
					setCustomEmail(response?.data?.sender_email);
					setCustomName(response?.data?.sender_name);
					customToast.success("Saved successfully!");
				}
			}
			if (response?.status === 200) {
				if (response?.data?.msg === "Sender email and domain added successfully and initiated verification process" && !response?.data?.is_sender_verified && !response?.data?.is_sender_domain_verified) {
					setVerificationTimer(60);
					setState((prevState) => {
						return {
							...prevState,
							showVerifyButton: false,
							loading: false,
							isSenderVerified: false,
							isSenderDomainVerified: false,
							dnsRecords: response?.data?.dns_records || null,
							saveBtnLoading: false
						}
					});
					setCustomEmail(response?.data?.sender_email);
					setCustomName(response?.data?.sender_name);
					customToast.success("Saved successfully!");
				}
			}
			if (response?.status === 200) {
				if (response?.data?.msg === "Sender email and domain verification successful" && response?.data?.is_sender_verified && response?.data?.is_sender_domain_verified) {
					setState({
						...state,
						showVerifyButton: false,
						isSenderVerified: true,
						isSenderDomainVerified: true,
						dnsRecords: response?.data?.dns_records || null,
						loading: false
					});
					setCustomEmail(response?.data?.sender_email);
					setCustomName(response?.data?.sender_name);
					customToast.success("Saved successfully!");
				}
			}
		} catch (error) {
			console.log(error);
			setState({ ...state, loading: false, saveBtnLoading: false });
			customToast.error(error.message);
		}
	};

	const removeSenderEmail = async eventId => {
		try {
			let response;
			if (isEventProfile) {
				response = await deleteSenderEmail(profileId, state?.data?.sendersEmail);   // <-- new API
			} else {
				response = await removeCustomSenderEmail(eventId, state?.data?.sendersEmail); // legacy
			}
			if (response.status === 204) {
				await getSenderEmailDetails(isEventProfile ? profileId : eventId);				// setState({...state,
			}
		} catch (error) {
			console.log(error);
			customToast.error(error.message);
		}
	};

	const validate = () => {
		if (!state.data.sendersName || state.data.sendersName.trim() === "") {
			const _state = state;
			_state.errors = {
				sendersName: "Please enter your name",
				sendersEmail: _state.errors.sendersEmail
			};
			setState({ ...state, ..._state });
			return false;
		}
		if (!/^[a-zA-Z0-9._, \(\)'!?-]+$/.test(
			state.data.sendersName
		)) {
			const _state = state;
			_state.errors = {
				sendersName: "Please enter a valid name",
				sendersEmail: _state.errors.sendersEmail
			};
			setState({ ...state, ..._state });
			return false;
		}
		if (!state.data.sendersEmail || state.data.sendersEmail.trim() === "") {
			const _state = state;
			_state.errors = {
				sendersEmail: "Please enter your email",
				sendersName: _state.errors.sendersName
			};
			setState({ ...state, ..._state });
			return false;
		}
		if (
			!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
				state.data.sendersEmail
			)
		) {
			const _state = state;
			_state.errors = {
				sendersEmail: "Please enter a valid email address",
				sendersName: _state.errors.sendersName
			};
			setState({ ...state, ..._state });
			return false;
		}
		if (checkPotentialDomainTypo(state.data.sendersEmail)) {
			const _state = state;
			_state.errors = {
				sendersEmail:
					"Please enter a valid email (there might be a typo in the email domain)",
				sendersName: _state.errors.sendersName
			};
			setState({ ...state, ..._state });
			return false;
		}
		return true;
	};
	useEffect(() => {
		if (isEventProfile) {
			getReplyEmail(profileId);
		} else {
			getReplyEmail(props?.eventInfo?.event_id);
		}

	}, [props]);
	useEffect(() => {
		if (!isApiCalled) {
			if (isEventProfile) {
				getSenderEmailDetails(profileId);
				setIsApiCalled(true);
			} else {
				if (props?.eventInfo?.event_id) {
					getSenderEmailDetails(props?.eventInfo?.event_id);
					setIsApiCalled(true);
				}
			}
		}
	}, [isApiCalled, props]);

	return (
		<>
			<KonfhubContainer>
			{isEventProfile &&	<BrandingAndCustomizationNote /> }
				<div
					className="customization_root"
					onClick={e => {
						e.stopPropagation();
						setIsEmailInputDisabled(state.showVerifyButton ? false : true);
					}}
				>
					<div className="mt-4">
						<Accordion
							onAccordionClick={onAccordionClick}
							accordion={accordion}
							setAccordion={setAccordion}
						>
							<div label="Custom Email">
								<div className="row">
									<div className="col-md-12">
										<label className="label">Custom sender email</label>
										<p className="mt-1 custom-reply-to-email-text">
											Set a custom sender email for all event communication, including automated attendee emails.
										</p>
									</div>
								</div>
								{state.value ? (
									<div
										style={{ height: "83px" }}
										className="w-100 d-flex align-items-center justify-content-center pb-2"
									>
										<span
											className={"spinner-border spinner-border-sm"}
											role="status"
											aria-hidden="true"
										></span>
									</div>
								) : (
									<div className="row w-100">
										<div id="eventName" className="col-xl-4 col-sm-12 mt-3">
											<label className="label" htmlFor="name">
												Sender Name
												<span className="text text-danger"> *</span>
											</label>
											<div
												className=""
												onClick={e => {
													e.stopPropagation();
												}}
											>
												<input
													type="text"
													className={
														state.errors.sendersName
															? "input border-danger px-2 "
															: "input px-2 "
													}
													id="sendersName"
													name="sendersName"
													placeholder="Enter sender name"
													value={state.data.sendersName}
													disabled={isRestricted}
													onChange={e => {
														e.stopPropagation();
														setState({
															...state,
															data: {
																sendersName: e.target.value,
																sendersEmail:
																	state.data.sendersEmail
															},
															errors: {
																sendersName: "",
																sendersEmail:
																	state.errors.sendersEmail
															}
														});
													}}
													onBlur={() => {
														if (
															!state.data.sendersName ||
															state.data.sendersName === ""
														) {
															const _state = state;
															_state.errors = {
																sendersName:
																	"Please enter your name",
																sendersEmail:
																	_state.errors.sendersEmail
															};
															setState({ ...state, ..._state });
														}
													}}
													autoComplete="off"
												/>
												{state.errors.sendersName && (
													<p className="custom-error-input-class text-danger pt-1">
														{state.errors.sendersName}
													</p>
												)}
											</div>
										</div>
										{/* Senders Email */}
										<div className="col-xl-4 col-sm-12  mt-3">
											<label className="label" htmlFor="shortName">
												Email Id
												<span className="text text-danger"> *</span>
												{/* <ToolTip data="A short name for this event that’s easy to recall. This would be used for the sender name when sending the emails as well (e.g., Registration confirmation email). Example: CCD20 for Cloud Community Days 2020. Allowed max 32 alpha-numeric characters, and also these special characters: underscore, hyphen, and whitespace." /> */}
											</label>
											<div className="">
												<div
													className="d-flex"
													onClick={e => {
														e.stopPropagation();
													}}
												>
													<input
														type="email"
														className={
															state.errors.sendersEmail
																? "input border-danger"
																: "input"
														}
														id="sendersEmail"
														name="sendersEmail"
														placeholder="Enter email id"
														disabled={isEmailInputDisabled || isRestricted}
														value={state?.data?.sendersEmail}
														onChange={e => {
															setState({
																...state,
																data: {
																	sendersEmail: e.target.value.toLowerCase(),
																	sendersName:
																		state?.data?.sendersName
																},
																errors: {
																	sendersEmail: "",
																	sendersName:
																		state.errors.sendersName
																}
															});
														}}
														onBlur={e => {
															if (
																!state?.data?.sendersEmail ||
																state?.data?.sendersEmail === ""
															) {
																const _state = state;
																_state.errors = {
																	sendersEmail:
																		"Please enter your email",
																	sendersName:
																		_state.errors.sendersName
																};
																setState({ ...state, ..._state });
															}
														}}
														autoComplete="off"
													/>
													{verificationTimer <= 0 && (
														<>
															{!state?.isSenderVerified && (
																<div
																	role="button"
																	className="d-flex align-items-center customization_edit_box"
																	onClick={e => {
																		e.stopPropagation();
																		setIsEmailInputDisabled(
																			false
																		);
																	}}
																>
																	<i
																		className="fas fa-pencil-alt"
																		style={{ color: dashboardColors[theme].primaryTextColor }}
																	></i>
																</div>
															)}
														</>
													)}
												</div>

												{state.errors.sendersEmail && (
													<p className="custom-error-input-class text-danger pt-1">
														{state.errors.sendersEmail}
													</p>
												)}
											</div>
										</div>


										{verificationTimer > 0 && !state.isSenderVerified && (
											<div
												className="col-xl-4 col-sm-12 d-flex align-items-end"
												style={{ height: "83px" }}
											>
												<div className="custom-error-input-class text-danger">{`Resend email in ${verificationTimer} seconds`}</div>
											</div>
										)}
										{verificationTimer <= 0 &&
											!state?.isSenderVerified &&
											customEmail !== state?.data?.sendersEmail && (
												<div
													className={`col-xl-4 col-sm-12 d-flex align-items-end`}
													style={{ height: "83px" }}
												>
													<button
														style={{
															width: state.loading ? "101px" : "85px"
														}}
														className="cancel-btn"
														disabled={isRestricted || state.loading}
														onClick={() => {
															if (validate() && !isRestricted) {
																setState({
																	...state,
																	loading: true
																});
																sendCustomSenderEmail(
																	isEventProfile ? profileId : props?.eventInfo?.event_id
																);
															}
														}}
													>
														Verify{state.loading ? "  " : ""}
														<span
															className={
																state.loading
																	? "spinner-border spinner-border-sm"
																	: ""
															}
															role="status"
															aria-hidden="true"
														></span>
													</button>
												</div>
											)}
										{verificationTimer <= 0 &&
											!state?.isSenderVerified &&
											customEmail === state?.data?.sendersEmail &&
											state?.loading === false && (
												<div
													style={{ height: "83px" }}
													className="col-xl-4 col-sm-12 customization_resend_email_text d-flex align-items-end"
												>
													<span
														role="button"
														onClick={() => {
															if (validate()) {
																setState({
																	...state,
																	loading: true
																});
																sendCustomSenderEmail(
																	props?.eventInfo?.event_id
																);
															}
														}}
													>
														Resend Email
													</span>
												</div>
											)}
										{verificationTimer <= 0 &&
											customEmail === state.data.sendersEmail &&
											!state.isSenderVerified &&
											state.loading && (
												<div
													style={{ height: "83px" }}
													className="col-xl-4 col-sm-12 d-flex align-items-end pb-2"
												>
													<span
														className={
															state.loading
																? "spinner-border spinner-border-sm"
																: ""
														}
														role="status"
														aria-hidden="true"
													></span>
												</div>
											)}
										{state.isSenderVerified && (
											<div
												style={{ height: "83px" }}
												className="col-xl-4 col-sm-12 d-flex align-items-end"
											>
												<div
													role="button"
													className="d-flex align-items-center customization-remove-text-wrapper"
													onClick={() => {
														setOpenDeleteModal(true);
													}}
												>
													<div>
														<i
															className="fas fa-trash"
															style={{ color: "#DC3545" }}
														></i>
													</div>
													<div className="customization_remove_text ml-1">
														Remove
													</div>
												</div>
											</div>
										)}
										<div className="mt-3 col-xl-12 col-sm-12 w-100">
											{
												state.isSenderVerified && state.isSenderDomainVerified && customEmail === state.data.sendersEmail ?
													<div className="d-flex">
														<div>
															<img src={GreenTick} alt="GreenTick" />
														</div>
														<div className="email-id-verified ml-1">Email ID & Domain Verified</div>
													</div>
													:
													state.isSenderVerified ?
														<div className="d-flex">
															<div>
																<img src={GreenTick} alt="GreenTick" />
															</div>
															<div className="email-id-verified ml-1">Email ID Verified</div>
														</div>
														:
														!state.isSenderVerified && customEmail === state.data.sendersEmail && (
															<div className="d-flex align-items-center mt-2">
																<div className="customization-check-your-email mr-2">{`Check your email and click on the link to verify`}</div>
																<div className="customization_warning_verify_wrapper d-flex align-items-center justify-content-between px-2 py-3">
																	<img
																		width={19}
																		src={Caution}
																		alt="warning_sign"
																	/>
																	<div className="customization_warning_verify align-self-center mt-1 ml-1">
																		{`Email Verification Pending`}
																	</div>
																</div>
																<div
																	role="button"
																	className="ml-2"
																	onClick={() => {
																		getSenderEmailDetails(
																			props?.eventInfo?.event_id,
																			false
																		);
																	}}
																>
																	<img
																		src={Refresh}
																		alt="refresh_icon"
																		className={loading ? "rotate" : ""}
																	/>
																</div>
															</div>
														)}
											{
												!state?.isSenderDomainVerified && customEmail === state.data.sendersEmail && (
													<div className="d-flex align-items-center mt-2">
														<div className="customization-check-your-email mr-1">{`For better email deliverability, verify your domain by adding these DNS records`}</div>
														<div className="mr-1">
															<ToolTip data={"To improve email deliverability, verify your domain by adding the necessary DNS (Domain Name System) records—such as SPF, DKIM, and DMARC—to your domain's DNS settings. These records confirm that you're an authorized sender and help ensure your emails land safely in your recipients’ inboxes."} />
														</div>
														<a className="customization-dns-records mr-2" href={state?.dnsRecords} download="dns_records.csv">{`DNS Records`}<span className="action ml-2">
															<i className="fas fa-download download"></i>
														</span></a>
														<div className="customization_warning_verify_wrapper d-flex align-items-center justify-content-between px-2 py-3">
															<img
																width={19}
																src={Caution}
																alt="warning_sign"
															/>
															<div className="customization_warning_verify align-self-center mt-1 ml-1">
																{`Domain Verification Pending`}
															</div>
														</div>
														<div
															role="button"
															className="ml-2"
															onClick={() => {
																getSenderEmailDetails(
																	props?.eventInfo?.event_id,
																	false
																);
															}}
														>
															<img
																src={Refresh}
																alt="refresh_icon"
																className={loading ? "rotate" : ""}
															/>
														</div>
													</div>
												)}
										</div>
										{state.isSenderVerified && (
											<div className="mt-3 col-xl-12 col-sm-12 w-100 d-flex justify-content-end">
												<button
													style={{
														width: state.saveBtnLoading
															? "115px"
															: "105px"
													}}
													className="k-btn save-btn"
													disabled={
														state.saveBtnLoading ||
														state.data.sendersName === customName
													}
													onClick={() => {
														if (validate()) {
															setState({
																...state,
																saveBtnLoading: true
															});
															setCustomName(state.data.sendersName);
															sendCustomSenderEmail(
																isEventProfile ? profileId : props?.eventInfo?.event_id
															);
														}
													}}
												>
													Save
													<span
														className={
															state.saveBtnLoading
																? "spinner-border spinner-border-sm ml-2 mt-1"
																: ""
														}
														role="status"
														aria-hidden="true"
													></span>
												</button>
											</div>
										)}
									</div>
								)}
								<form onSubmit={formik.handleSubmit}>
									<div className="row">
										<div className="col-md-12 mt-4">
											<label className="label">Custom Reply-To Email</label>
											<p className="mt- custom-reply-to-email-text">
												Set a custom reply-to email for your event communications to ensure participant responses go directly to your preferred inbox.
											</p>
										</div>
									</div>
									<div id="eventName" className="col-xl-4 col-sm-12 px-0">
										<label className="label" htmlFor="reply_to_address">
											Email Id <span className="text text-danger">*</span>
										</label>
										<div>
											<input
												type="email"
												className={`input px-2 ${formik.touched.reply_to_address && formik.errors.reply_to_address
													? "border-danger"
													: ""
													}`}
												id="reply_to_address"
												name="reply_to_address"
												placeholder="Enter email id"
												disabled={isRestricted}
												value={formik.values.reply_to_address}
												onChange={(e) => {
													e.target.value = e.target.value.toLowerCase();
													formik.handleChange(e);
												}}
												onBlur={formik.handleBlur}
												autoComplete="off"
											/>
											{formik.touched.reply_to_address && formik.errors.reply_to_address && (
												<p className="custom-error-input-class text-danger pt-1">
													{formik.errors.reply_to_address}
												</p>
											)}
										</div>
									</div>

									<div className="mt-3  col-xl-12 col-sm-12 w-100 d-flex justify-content-end">
										<button
											type="submit"
											style={{
												width: formik.isSubmitting ? "115px" : "105px",
											}}
											className="k-btn save-btn mr-3"
											disabled={
												formik.isSubmitting ||
												formik.values.reply_to_address === initialReplyToEmail
											}
										>
											Save
											{formik.isSubmitting && (
												<span
													className="spinner-border spinner-border-sm ml-2 mt-1"
													role="status"
													aria-hidden="true"
												></span>
											)}
										</button>
									</div>

								</form>
							</div>
						</Accordion>
					</div>
					{!isEventProfile && <>
						<div>
							<Accordion
								onAccordionClick={onAccordionClick}
								accordion={accordion}
								setAccordion={setAccordion}
							>
								<div label="Website Integrations">
									<WebsiteIntegrations
										eventInfo={props?.eventInfo}
										isRestricted={isRestricted}
									/>
								</div>
							</Accordion>
						</div>
						<div>
							<Accordion
								onAccordionClick={onAccordionClick}
								accordion={accordion}
								setAccordion={setAccordion}
							>
								<div label="Share On LinkedIn Customization">
									<LinkedInShareCustomization
										eventDetails={props?.eventInfo}
										isRestricted={isRestricted}
									/>
								</div>
							</Accordion>
						</div></>}
				</div>
			</KonfhubContainer>
			{openDeleteModal && (
				<DeleteModal
					openModal={openDeleteModal}
					setOpenModal={setOpenDeleteModal}
					onOkay={() => {
						setOpenDeleteModal(false);
						removeSenderEmail(isEventProfile ? profileId : props?.eventInfo?.event_id);
					}}
					onCancel={() => {
						setOpenDeleteModal(false);
					}}
					primaryBtnContent={"Yes, remove"}
					text={"Are you sure about removing your custom email id?"}
					subText={
						"Please note that by doing so, you will be required to verify the newly added email id again."
					}
					width={"30%"}
				/>
			)}
			<style jsx>
				{`
					.rotate {
						animation: spin 1s linear infinite;
					}

					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
					.email-id-verified {
						font-family: Hind;
						font-weight: 500;
						font-size: 15px;
						color: ${websiteColors["dark"].green};
						margin-top: 2px;
					}
					.customization-remove-text-wrapper {
						height: 30px;
					}
					.customization-check-your-email {
						font-family: Hind;
						font-weight: 400;
						font-style: Regular;
						font-size: 14px;
						line-height: 100%;
						color: ${dashboardColors[theme].primaryTextColor}
					}
					.customization-dns-records {
						font-family: Hind;
						font-weight: 400;
						font-style: Regular;
						font-size: 15px;
						letter-spacing: 0%;
						text-decoration: underline;
						color: ${colors[theme].blue};
						cursor: pointer;
					}
					.customization-dns-records:focus, .customization-dns-records:hover {
						color: ${colors[theme].blue};
					}
					.customization-dns-records.download {
						color: ${colors[theme].blue};
						font-size: 10px;
					}
					.customization-dns-records.download:focus, .customization-dns-records.download:hover {
						color: ${colors[theme].blue};
						font-size: 10px;
					}
					.customization_warning_verify_wrapper {
						height: 33px;
						padding: 4px 10px 4px 10px;
						border-radius: 2px;
						background: #fff6ea;
					}
					.customization_warning_verify {
						font-family: Hind;
						font-size: 14px;
						font-weight: 500;
						line-height: 17px;
						letter-spacing: 0em;
						color: #f1a81b;
					}
					.customization_resend_email_text {
						font-family: Hind;
						font-size: 15px;
						font-weight: 400;
						line-height: 24px;
						letter-spacing: 0em;
						color: #007bff;
						text-decoration: underline;
					}
					.customization_verified_wrapper {
						padding: 4px 10px 4px 10px;
						border-radius: 2px;
						background: #e1ffeb;
					}
					.customization_verified_text {
						font-family: Hind;
						font-size: 15px;
						font-weight: 400;
						line-height: 24px;
						letter-spacing: 0em;
						color: #0bc54a;
					}
					.customization_remove_text {
						font-family: Hind;
						font-size: 15px;
						font-weight: 400;
						line-height: 24px;
						letter-spacing: 0em;
						text-decoration: underline;
						color: #dc3545;
					}
					.custom-reply-to-email-text{
						font-size: 14px;
						font-weight: 400;
						color: #6C757D;
					}
					.customization_edit_box {
						border-radius: 0px 2px 2px 0px;
						border-top: 1px solid #cdd4db;
						border-bottom: 1px solid #cdd4db;
						border-right: 1px solid #cdd4db;
						margin-left: -1px;
						padding-left: 15px;
						padding-right: 15px;
					}
				`}
			</style>
		</>
	);
};

export default Customization;
